// extracted by mini-css-extract-plugin
module.exports = {"additionalImageContainer":"gallery-additional-image-layer_additionalImageContainer__H_IZi","additionalImageCount":"gallery-additional-image-layer_additionalImageCount__YP6dN"};